import { useTranslation } from 'react-i18next';
import { Typography } from '@react-md/typography';
import { FeatureContent } from '@components/feature-content';
import { getNodeIdComposer } from '@utils';
import { RootPrefix } from './constants';

const _id = getNodeIdComposer(RootPrefix, 'header');

export const InventoryHeader = () => {
    const { t } = useTranslation();
    return (
        <div className="base-paddings">
            <Typography id={_id('title')} type="headline-3" component="h1">
                <FeatureContent contentKey={_id('title')} fallback={t('titles.inventory', 'Inventory')} />
            </Typography>
        </div>
    );
};
